import GenericAnalogSensor, { defaultGenericAnalogSensor } from './GenericAnalogSensor';

export default interface GnssSensor extends GenericAnalogSensor {
  '@type': 'gnss_sensor';
}

const { '@type': _, ...defaultSensorWithoutType } = defaultGenericAnalogSensor;

export const defaultGnssSensor: GnssSensor = {
  '@type': 'gnss_sensor',
  ...defaultSensorWithoutType,
};
